import { RgChildren as s, RG_TYPE as c } from "@project-rouge/rg-core";
import { memo as f, useMemo as h } from "react";
import { RgMergeFC as u } from "./index6.js";
import { jsx as i, Fragment as a } from "react/jsx-runtime";
const t = s.Building.filter((r) => r !== c.Apartment), C = f(({
  building: r,
  layer: o,
  visibility: l,
  colourFunc: m,
  addUVs: p = [],
  ...d
}) => {
  const g = h(() => {
    const e = Array(t.length).fill(0).map(() => []);
    for (const n of r.children)
      !t.includes(n.type) || e[t.indexOf(n.type)].push(n);
    return e;
  }, [r]);
  return /* @__PURE__ */ i(a, {
    children: g.map((e, n) => /* @__PURE__ */ i(u, {
      objs: e,
      parent: r,
      layer: o,
      visibility: l,
      colourFunc: m,
      addUVs: !!e.length && p.includes(e[0].type),
      ...d
    }, n))
  });
});
C.displayName = "MergeBuildingChildrenFC";
export {
  t as ChildrenToMerge,
  C as MergeBuildingChildrenFC
};
//# sourceMappingURL=index4.js.map
